import { DataService } from "../../libs/services/index.js";

export class FirebaseConfig {
  instance;
  queue = [];

  async loadModule() {
    const [module] = await Promise.all([
      import("@firebase/app"),
      import("@firebase/auth"),
      import("@firebase/database")
    ]);
    return module.default;
  }

  async getToken(accountId) {
    const [getTokenRequest] = DataService.get(
      `/notification/2/${accountId}/token`
    );

    let { custom_token: customToken } = await getTokenRequest();
    return customToken;
  }

  async init(accountId, config) {
    let firebase = await this.loadModule();
    let app;
    if (!firebase.apps.length) {
      app = firebase.initializeApp(config);
    } else {
      app = firebase.app();
    }

    let customToken = await this.getToken(accountId);

    await app
      .auth()
      .setPersistence(firebase.auth.Auth.Persistence.NONE)
      .then(async () => {
        return await app.auth().signInWithCustomToken(customToken);
      });

    this.queue.forEach((item) => {
      let path = item.path;
      let ref = app.database().ref(path);

      ref.on("value", item.callback);
    });

    this.instance = app;

    return app;
  }

  signout() {
    this.instance.auth().signOut();
    localStorage.setItem("isSessionExpired", true);
  }

  subscribe({ accountId, module, subModule, subModuleInstance }) {
    let ref = null;
    let path;

    path = [accountId, module, subModule, subModuleInstance]
      .filter(Boolean)
      .join("/");

    return {
      on: (eventName, callback) => {
        if (this.instance) {
          ref = this.instance.database().ref(path);
          ref.on(eventName, (response) => {
            let value = response.val() || undefined;
            callback(value);
          });
        } else {
          this.queue.push({
            path: path,
            callback: (response) => {
              let value = response.val() || undefined;
              callback(value);
            }
          });
        }
      },
      once: (eventName, callback) => {
        if (this.instance) {
          ref = this.instance.database().ref(path);
          ref.once(eventName, (response) => {
            let value = response.val() || undefined;
            callback(value);
          });
        }
      },
      off: () => {
        if (ref) {
          ref.off("value");
        }
      }
    };
  }
}
